import { useRef, useState } from "react";
import { Select } from "components/UI/form/Select";
import st from "@/styles/modules/typography.module.scss";
import s from "./SamplesFilterDesktopForm.module.scss";
import { FormFieldParams, getFilterFormFields } from "@/components/forms/filterFormFields";
import styles from "@/components/UI/form/Input.module.scss";
import { UnitField } from "@/content/samples/types";
import { InputNumber } from "@/components/UI/form/InputNumber";
import { FilterParam, SelectedValues } from "@/utils/usePageFIlters";
import { debounce } from "lodash";
import cn from "classnames";
import { TabButtons } from "@/components/shared/TabButtons";
import { InputNumberRange } from "@/components/UI/form/InputNumberRange";
import { WordsPagesInput } from "@/components/UI/form/WordsPagesInput";

type SamplesFilterDesktopFormProps = {
  selectedValues: SelectedValues;
  onChange: Function;
  filterParams?: FormFieldParams;
  className?: string;
};

export const SamplesFilterDesktopForm = ({
  selectedValues,
  onChange,
  filterParams = { set: "basic" },
  className,
}: SamplesFilterDesktopFormProps) => {
  const form = useRef<HTMLFormElement | null>(null);

  const fields = getFilterFormFields(filterParams);

  const onSubmit = debounce((event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();
    if (!form.current) return;
    const data = new FormData(form.current);

    const newValues: SelectedValues = {};

    for (let pair of data.entries()) {
      const key = pair[0] as FilterParam;
      if (["pagesFrom", "pagesTo", "page", "wordsFrom", "wordsTo", "title"].includes(pair[0]) && pair[1]) {
        // @ts-ignore
        newValues[key] = pair[1];
      } else {
        // @ts-ignore
        newValues[key] = pair[1] ? String(pair[1]).split(",") : [];
      }
    }
    onChange(newValues);
  }, 200);

  const handleWordsPagesTabChange = (value: UnitField) => {
    onSubmit();
  };

  return (
    <form ref={form} onSubmit={onSubmit} className={cn(s.wrapper, className)}>
      <p className={st.headingH4}>Filters:</p>
      <div className={s.inner}>
        {fields.map((field) => (
          <Select
            key={field.name}
            {...field}
            mode="multiple"
            onChange={() => onSubmit()}
            initialValue={
              Array.isArray(selectedValues[field.name])
                ? (selectedValues[field.name] as (string | number)[]).map(String)
                : typeof selectedValues[field.name] === "string"
                ? (selectedValues[field.name] as string).split(",")
                : []
            }
          />
        ))}
        <div className={styles.input}>
          <span className={styles.inputLabel}>Volume</span>
          <WordsPagesInput
            initialField={selectedValues.wordsFrom || selectedValues.wordsTo ? "words" : "pages"}
            onTabChange={handleWordsPagesTabChange}
            onWordsChange={() => onSubmit()}
            onPagesChange={() => onSubmit()}
            initialWordsValue={{
              from: selectedValues.wordsFrom ? String(selectedValues.wordsFrom) : undefined,
              to: selectedValues.wordsTo ? String(selectedValues.wordsTo) : undefined,
            }}
            initialPagesValue={{
              from: selectedValues.pagesFrom ? String(selectedValues.pagesFrom) : undefined,
              to: selectedValues.pagesTo ? String(selectedValues.pagesTo) : undefined,
            }}
          />
        </div>
      </div>
    </form>
  );
};
